import * as actionlist from '../actions/dashboardactions';
import moment from 'moment';
const state = {
    search: '',
    page: 0,
    date: moment().toDate(),
    
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    date: state => state.date,
    
};

const actions = {
    [actionlist.DASHBOARDLIST_SEARCH]: ({ commit }, search) => {
        commit(actionlist.DASHBOARDLIST_SEARCH, search);
    },
    [actionlist.DASHBOARDLIST_PAGE]: ({ commit }, page) => {
        commit(actionlist.DASHBOARDLIST_PAGE, page);
    },
    [actionlist.DASHBOARDLIST_DATE]: ({ commit }, date) => {
        commit(actionlist.DASHBOARDLIST_DATE, date);
    }, 
    
};

const mutations = {
    [actionlist.DASHBOARDLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionlist.DASHBOARDLIST_PAGE]: (state, page) => {
        state.page = page;
    },
    [actionlist.DASHBOARDLIST_DATE]: (state, date) => {
        state.page = 0;
        state.date = date;
    },
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
